import React from 'react';
import '../App.css';
import { useTranslation } from 'react-i18next';

function InvestingPage() {
  const { t } = useTranslation(); // 預設 namespace 'translation'

  return (
    <div className="article-container">
      <h1>{t('investingPage.title')}</h1>
      <p>{t('investingPage.paragraph1')}</p>
      <p>{t('investingPage.paragraph2')}</p>
      <p>{t('investingPage.paragraph3')}</p>

      <p>
        <h2>{t('investingPage.firstLessonHeading')}</h2>
      </p>

      <p>{t('investingPage.paragraph4')}</p>
      <p>{t('investingPage.paragraph5')}</p>
      <p>{t('investingPage.paragraph6')}</p>
    </div>
  );
}

export default InvestingPage;
